import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  InputAdornment
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search"; // Make sure to import this
import collegesData from "../data/colleges.json";

const Colleges = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  // Filter colleges based on search
  const filteredColleges = collegesData.filter((college) =>
    college.Institute_Name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box sx={{ bgcolor: "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      
      {/* Fixed Header with Search Bar */}
      <Box sx={{ p: 2, borderBottom: "1px solid #eee", position: "sticky", top: 0, bgcolor: "#fff", zIndex: 10 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search College"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              bgcolor: "#f9f9f9"
            }
          }}
        />
      </Box>

      {/* Scrollable List Area */}
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        {filteredColleges.map((college) => (
          <Box
            key={college.Institute_Code}
            onClick={() => navigate(`/college/${college.Institute_Code}`)}
            sx={{
              py: 2,
              px: 2,
              borderBottom: "1px solid #f0f0f0",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start", // Aligns items to top so multiline names look good
              "&:hover": {
                bgcolor: "#f5f5f5"
              }
            }}
          >
            {/* Left Side: Name and District */}
            <Box sx={{ flex: 1, mr: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  color: "black",
                  lineHeight: 1.3,
                  mb: 0.5
                }}
              >
                {college.Institute_Name}
              </Typography>
              
              <Typography
                variant="body2"
                sx={{
                  color: "#1976d2", // The blue color from your screenshot
                  fontSize: "0.85rem",
                  fontWeight: 500
                }}
              >
                {college.District}
              </Typography>
            </Box>

            {/* Right Side: Code Badge */}
            <Box
              sx={{
                bgcolor: "#f0f0f0",
                color: "#666",
                borderRadius: "12px",
                px: 1.5,
                py: 0.5,
                fontSize: "0.75rem",
                fontWeight: 600,
                whiteSpace: "nowrap",
                mt: 0.5 // Slight margin to align with the first line of text
              }}
            >
              {college.Institute_Code}
            </Box>
          </Box>
        ))}

        {/* No Results Message */}
        {filteredColleges.length === 0 && (
          <Typography sx={{ mt: 4, textAlign: "center", color: "gray" }}>
            No colleges found.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Colleges;